export default {"src":"/_next/static/media/logo-1.2379184f.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};